const Backbone = require('backbone');
const RecommendedOptionModel = require('models/store/client/product/recommendedoption');
const QuantityView = require('views/store/common/quantity');
const format = require('format');
const dustjs = require('dustjs');
const _finishSelectDust = require('store/global/pages/products/_finish_select.dust');
var RecommendedOptionView = Backbone.View.extend({
	model: RecommendedOptionModel,
	initialize: function(options) {
		this.options = Object.assign({}, options);
		var self = this,
			$selectedOption = self.$('select option:selected'),
			selectedOptionUniqueId = parseInt($selectedOption.val(), 10),
			selectedOptionName = $selectedOption.text().split(' - ')[0];

		self.ui = {
			selectedPrice: self.$('.js-selected-price')
		};

		self.childViews = {
			quantity: new QuantityView({
				el: self.$('.quantity'),
				id: self.model.cid
			})
		};

		self.model.finishes.setSelectedFinishByUniqueId({
			uniqueId: selectedOptionUniqueId,
			name: selectedOptionName
		});
		self.listenTo(Backbone, 'quantity:changed', self.updateQuantity, self);
		self.listenTo(Backbone, 'recommendedOptionFinish:change', self.render, self);
		self.isConfigured = false;

		// Needed for pages that don't initially perform a render call
		this._toggleShowMore(self);
	},

	events: {
		'change select': '_finishOptionChanged',
		'change input[type="checkbox"]': 'updateIsNeeded',
		'click .js-rec-product-image': '_productClicked',
		'click .js-change-option-link': '_transitionConfigurationState',
		'click .js-remove-option-link': '_removeOption'
	},

	updateIsNeeded: function(event) {
		this.model.set('isNeeded', !event.currentTarget.checked);
	},

	matchOptionQuantityToProductQuantity: function() {
		var quantityView = this.childViews.quantity;
		quantityView.setQuantity(this.model.get('quantity'));
		quantityView.render();
		this.render();
	},

	render: function(isFinishChange) {
		var selectedOptionModel = this.model.getSelected(),
			price,
			$select = this.$('select'),
			productData;

		if (selectedOptionModel.length === 0) {
			// This was blowing up before so we'll just return now.
			return;
		}

		selectedOptionModel = selectedOptionModel[0].toJSON();
		price = (selectedOptionModel.price * this.model.get('quantity')).toFixed(2);
		productData = {
			product: this.model.getProductWithFinishUniqueId(selectedOptionModel.uniqueId)
		};

		this.$('.js-selected-price').html(`$${price}`);
		this.$('.js-selected-manufacturer').html(`${selectedOptionModel.manufacturer} ${selectedOptionModel.productId}`);
		this.$('.js-product-title').html(selectedOptionModel.title);
		this.$('.js-product-summary, .js-modal-configureInformation .modal-body').html(selectedOptionModel.description);
		this.$('.js-product-finish').html(selectedOptionModel.finish);
		this.$('.js-quantity-display').html(this.model.get('quantity'));

		const matchingFinish = this.model.get('finishes').filter((currentFinish) => {
			return currentFinish.uniqueId === selectedOptionModel.uniqueId;
		})[0];

		const $theImage = this.$('.js-rec-product-image').filter(function() {
			return String($(this).data('productId')) === String(matchingFinish.productId);
		});

		$theImage.attr('src', matchingFinish.images['100']);
		$theImage.data('unique-id', matchingFinish.uniqueId);

		if (parseInt($select.val(), 10) !== selectedOptionModel.uniqueId) {
			dustjs.render(_finishSelectDust, productData, (error, markup) => {
				$select.replaceWith(markup);
				this.$('select').val(selectedOptionModel.uniqueId);
			});
		}

		if (!isFinishChange) {
			this.$('.rec-product-container .current-selection').removeClass('current-selection');
			this.$(`[data-product-id="${productData.product.productId}"]`).addClass('current-selection');
			this.$(`[data-id-for-selection="${productData.product.productId}"]`).addClass('current-selection');
		}

		this._toggleShowMore(self);
	},

	updateQuantity: function(data) {
		if (data.id === this.model.cid) {
			this.model.set('quantity', data.quantity);
			this.render();
		}
	},

	_productClicked: function(event) {
		const $currentTarget = $(event.currentTarget),
			uniqueId = $currentTarget.data('uniqueId');

		this._updateSelected({
			uniqueId
		});
	},

	_finishOptionChanged: function(event) {
		this._updateSelected(
			{
				uniqueId: parseInt(event.currentTarget.value, 10),
				finish: $(event.target)
					.find('option')
					.filter(function() {
						return $(this).prop('selected');
					})
					.text()
					.split(' - ')[0]
			},
			true
		);
	},

	_updateSelected: function(data, isFinishChange) {
		this.model.finishes.setSelectedFinishByUniqueId({
			uniqueId: data.uniqueId,
			finish: data.finish
		});

		this.model.getSelected().forEach((selectedFinishModel) => {
			selectedFinishModel.set({
				manuallySelected: true
			});

			Backbone.trigger('recommendedOptionFinish:clicked', selectedFinishModel.toJSON());
			this.render(isFinishChange);
		});
	},

	_transitionConfigurationState: function() {
		if (this.$el.hasClass('unconfigured')) {
			this.$el.removeClass('unconfigured').addClass('configuring');
		} else if (this.$el.hasClass('configuring')) {
			this.$el.removeClass('configuring').addClass('configured');
			this._updateFooterSummary();
		} else {
			this.$el.removeClass('configured').addClass('configuring');
			this._updateFooterSummary();
		}
	},

	_removeOption: function() {
		this.$el.removeClass('configuring configured').addClass('unconfigured');
		this._updateFooterSummary();
	},

	_toggleShowMore: function() {
		var $psElement = this.$('div.product-summary');
		var $showMoreElement = this.$('.show-if-overflow');
		$showMoreElement.toggle($psElement.outerHeight() !== $psElement.prop('scrollHeight'));
	},

	_updateFooterSummary: function() {
		var self = this,
			selectedOptionModel = self.model.getSelected()[0].toJSON(),
			qty = self.model.get('quantity'),
			price = (selectedOptionModel.price * qty).toFixed(2),
			$summaryItemList = $('.js-additonal-options-container');
		if ($summaryItemList.length) {
			if (this.$el.hasClass('configured')) {
				$summaryItemList.append(
					$('<li></li>')
						.addClass(`summary-${selectedOptionModel.productId}`)
						.html(
							`+ <b>${self.model.get('name')}</b> ${selectedOptionModel.title}${
								qty > 1 ? ` x${qty}` : ''
							} - <span class="text-green">${format.currency(price)}</span>`
						)
						.data('price', price)
				);
			} else {
				$summaryItemList.find(`.summary-${selectedOptionModel.productId}`).remove();
			}
		}
	}
});

module.exports = RecommendedOptionView;
